import { LoadingOverlayComponent } from '../shared/components/loading-overlay/loading-overlay.component';

import { AuthService } from './auth.service';

import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-logout',
  template: `
    <app-loading-overlay text="Sie werden ausgeloggt..." [fullScreen]="true">
    </app-loading-overlay>
  `,
  imports: [LoadingOverlayComponent],
})
export class LogoutComponent {
  public auth = inject(AuthService);
  constructor() {
    this.auth.logout();
  }
}
